import { DeviceEntryProps, DeviceType } from '@ixicare/resources';
import { formatDate } from '@ixicare/ui';
import {
  WEARABLE_COLUMNS,
  WEARABLE_COLUMN_IDS,
  transformWearableToRow,
  BUTTON_COLUMNS,
  BUTTON_COLUMN_IDS,
  transformButtonToRow,
  EVIEW_COLUMNS,
  EVIEW_COLUMN_IDS,
  transformEviewToRow,
  API_COLUMNS,
  API_COLUMN_IDS,
  transformApiToRow,
} from '../rowTransformers';
import { BaseTableConfig, CsvAccessor, WithColumnManager, WithExport, WithTransformer } from '../types';
import { wearableSortAccessors, buttonSortAccessors, eviewSortAccessors, apiSortAccessors } from './sortAccessors';

const updatedOnCsvAccessor: CsvAccessor<DeviceEntryProps> = (d) =>
  d.status?.updatedOn ? formatDate(d.status.updatedOn) : null;

export const wristwatchTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'wristwatches',
  deviceTypes: [DeviceType.WATCHERR, DeviceType.IXI_PRO],
  columns: WEARABLE_COLUMNS,
  columnIds: WEARABLE_COLUMN_IDS,
  rowsSelectable: true,
  transformRow: transformWearableToRow,
  sortAccessors: wearableSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
};

export const wristbandTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'wristbands',
  deviceTypes: [DeviceType.WRISTBAND_DISTRESS_BUTTON, DeviceType.IXI_LITE, DeviceType.IXI_BLACK, DeviceType.IXI_TOUCH],
  columns: WEARABLE_COLUMNS,
  columnIds: WEARABLE_COLUMN_IDS,
  rowsSelectable: true,
  defaultColumnIds: WEARABLE_COLUMN_IDS.filter((c) => !['phone_number', 'imei_number'].includes(c)),
  transformRow: transformWearableToRow,
  sortAccessors: wearableSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
};

export const buttonTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'buttons',
  deviceTypes: [DeviceType.WALL_MOUNTED_DISTRESS_BUTTON],
  columns: BUTTON_COLUMNS,
  columnIds: BUTTON_COLUMN_IDS,
  rowsSelectable: true,
  transformRow: transformButtonToRow,
  sortAccessors: buttonSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
  defaultOrderBy: 'updated_on',
  defaultAscOrder: true,
};

export const eviewTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'eviews',
  deviceTypes: [DeviceType.EVIEW],
  columns: EVIEW_COLUMNS,
  columnIds: EVIEW_COLUMN_IDS,
  rowsSelectable: true,
  transformRow: transformEviewToRow,
  sortAccessors: eviewSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
};

export const apiTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'api',
  deviceTypes: [DeviceType.API_EXTERNAL],
  columns: API_COLUMNS,
  columnIds: API_COLUMN_IDS,
  rowsSelectable: true,
  transformRow: transformApiToRow,
  sortAccessors: apiSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
};

export const twigTableConfig: BaseTableConfig &
  WithTransformer<DeviceEntryProps> &
  WithColumnManager<DeviceEntryProps> &
  WithExport<DeviceEntryProps> = {
  tableId: 'twigs',
  deviceTypes: [DeviceType.TWIG],
  columns: EVIEW_COLUMNS,
  columnIds: EVIEW_COLUMN_IDS,
  rowsSelectable: true,
  transformRow: transformEviewToRow,
  sortAccessors: eviewSortAccessors,
  csvAccessors: { updated_on: updatedOnCsvAccessor },
};
